module.exports = __webpack_public_path__ + "media/images/admin/icons/headphones-577f279c23a7ee0f4917041279533564.svg";